import React, { useState,useEffect } from 'react';
import { Button } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import * as RestService from '../../services/eisRest';

import DocumentPrintTemplate1 from '../reports/DocumentPrintTemplate1';

const DocumentPrint  = React.forwardRef((props, ref) => {

    const [t] = useTranslation();            
    
    const [document, setDocument] = useState({transactionType: ''});  
 
    useEffect(() => {       
      
      setDocument(props.document);
     
    
    }, [props.document])

    return (
    <div ref={ref}>
      {props.document ?
          <DocumentPrintTemplate1
            document={document}
           
          />
                      :
                      <></>
      }
    </div>
  );
});

export default DocumentPrint;